import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedTargetingStepWithI18n =
  () => import(/* webpackChunkName: 'targeting-step.async' */'./targeting-step')
    .then(({ TargetingStepWithI18n }) => TargetingStepWithI18n);

const DelayedTargetingLazyRepository =
  () => import(/* webpackChunkName: 'targeting-step.async' */'./targeting-lazy-repository')
    .then(({ TargetingLazyRepositoryWithI18n }) => TargetingLazyRepositoryWithI18n);

export const TargetingStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.TARGETING,
  view: DelayedTargetingStepWithI18n,
  repository: DelayedTargetingLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
};
